export const generatePKCEPair = async () => {
  const NUM_OF_BYTES = 22 // Total of 44 characters (1 Bytes = 2 char) (standard states that: 43 chars <= verifier <= 128 chars)
  const randomBytes = crypto.getRandomValues(new Uint8Array(NUM_OF_BYTES))
  let randomVerifier = ''
  for (let i = 0; i < randomBytes.length; i++) {
    randomVerifier += randomBytes[i].toString(16).padStart(2, '0')
  }
  const digest = new Uint8Array(
    await crypto.subtle.digest(
      'SHA-256',
      new TextEncoder().encode(randomVerifier)
    )
  )
  let binary = ''
  for (let i = 0; i < digest.length; i++) {
    binary += String.fromCharCode(digest[i])
  }
  const challenge = btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '') // Clean base64 to make it URL safe
  return { verifier: randomVerifier, challenge }
}
